export const TIMESTAMP_MATCH_THRESHOLD_MS = 5000

export const THREAD_EVENTS_PAGE_SIZE = 50

export const MAX_CHAT_FILE_SIZE = 50 * 1024 * 1024

export const CHAT_FILE_ACCEPT_TYPES: Record<string, string[]> = {
    "text/csv": [".csv"],
    "application/pdf": [".pdf"],
    "text/plain": [".txt"],
    "application/msword": [".doc"],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
        ".docx",
    ],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
    ],
    "text/x-python": [".py"],
    "text/typescript": [".ts", ".tsx"],
    "image/png": [".png"],
    "image/jpeg": [".jpg", ".jpeg"],
    "image/gif": [".gif"],
    "image/webp": [".webp"],
    "image/tiff": [".tiff", ".tif"],
}

export const CHAT_RUN_STALL_TIMEOUT_MS = 45_000

export const CHAT_RUN_NOT_STREAMABLE_POLL_MS = 2_000

export const OPTIMISTIC_THREAD_ID_PREFIX = "optimistic-"

export const PENDING_THREAD_ID_PREFIX = "pending-"

export const PLACEHOLDER_THREAD_ID_PREFIXES = [
    OPTIMISTIC_THREAD_ID_PREFIX,
    PENDING_THREAD_ID_PREFIX,
] as const

export function isPlaceholderThreadId(threadId: string): boolean {
    return PLACEHOLDER_THREAD_ID_PREFIXES.some(prefix =>
        threadId.startsWith(prefix)
    )
}
